export const FETCH_ALL_CATEGORIES_REQUEST='FETCH_ALL_CATEGORIES_REQUEST'
export const FETCH_ALL_CATEGORIES_SUCCESS='FETCH_ALL_CATEGORIES_SUCCESS'
export const FETCH_ALL_CATEGORIES_FAILURE='FETCH_ALL_CATEGORIES_FAILURE'

export const FILTER_CATEGORY_REQUEST='FILTER_CATEGORY_REQUEST'
export const FILTER_CATEGORY_SUCCESS='FILTER_CATEGORY_SUCCESS'
export const FILTER_CATEGORY_FAILURE='FILTER_CATEGORY_FAILURE'